
let href = '../../analytics-reports-js-components-web/css/cms_performance.(SCPpEBogUn0).css';
if (window.getComputedStyle(document.documentElement).direction === 'rtl') {
	href = '../../analytics-reports-js-components-web/css/cms_performance_rtl.(SCPpEBogUn0).css';
}

href = import.meta.resolve(href);
const link = document.createElement('link');
link.setAttribute('rel', 'stylesheet');
link.setAttribute('type', 'text/css');
link.setAttribute('href', href);
if (Liferay.CSP) {
	link.setAttribute('nonce', Liferay.CSP.nonce);
}
document.querySelector('head').appendChild(link);
